import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import { queryKeys } from '@/api/query-keys'

async function deactivateSignalProvider(platformUserId: string): Promise<void> {
  await apiClient.patch(
    `/api/v1/platform/signal-providers/${encodeURIComponent(platformUserId)}/deactivate`,
  )
}

async function reactivateSignalProvider(platformUserId: string): Promise<void> {
  await apiClient.patch(
    `/api/v1/platform/signal-providers/${encodeURIComponent(platformUserId)}/reactivate`,
  )
}

export function useDeactivateSignalProvider() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: deactivateSignalProvider,
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.signalProviders.all() }),
  })
}

export function useReactivateSignalProvider() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: reactivateSignalProvider,
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.signalProviders.all() }),
  })
}
